module.exports = __webpack_public_path__ + "static/media/avatar45.db4b14ba.png";